module.exports = __webpack_public_path__ + "static/media/welcome_sound.27c69098.mp3";